import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { cl_api } from '@/api';
import type { ClChild } from '@/types';

export const useLearnerStore = defineStore('cl_learner', () => {
  const cl_children = ref<ClChild[]>([]);
  const cl_activeChildId = ref(localStorage.getItem('cl_active_child') ?? '');
  const cl_activeChild = computed(() => cl_children.value.find((cl_child) => cl_child.id === cl_activeChildId.value) ?? cl_children.value[0] ?? null);

  async function cl_load() {
    cl_children.value = (await cl_api.get('/children')).data;
    if (!cl_children.value.some((cl_child) => cl_child.id === cl_activeChildId.value)) cl_select(cl_children.value[0]?.id ?? '');
  }
  function cl_select(cl_childId: string) { cl_activeChildId.value = cl_childId; localStorage.setItem('cl_active_child', cl_childId); }
  async function cl_create(cl_name: string, cl_birthYear?: number) { const cl_child = (await cl_api.post('/children', { cl_name, cl_birthYear })).data; cl_children.value.push(cl_child); cl_select(cl_child.id); }
  async function cl_updateProfile(cl_profile: { cl_accent: 'EN_US' | 'EN_GB'; cl_dailyGoalMinutes: number; cl_parentModeNumbers: boolean }) {
    if (!cl_activeChildId.value) return;
    await cl_api.patch(`/children/${cl_activeChildId.value}/profile`, cl_profile);
    await cl_load();
  }
  return { cl_children, cl_activeChildId, cl_activeChild, cl_load, cl_select, cl_create, cl_updateProfile };
});
